import IpsCheckbox from './IpsCheckbox.vue';
import '../../../styles/custom.scss';

export default IpsCheckbox;
